import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=2ee123f6&scoped=true"
var script = {}
import style0 from "./preloader.scss?vue&type=style&index=0&id=2ee123f6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee123f6",
  null
  
)

export default component.exports